import CouponControls from "./CouponControls";
import BeatCard from "./BeatCard";

function BeatsSection(props) {
  const { beats = [] } = props;

  return (
    <>
      <div className="yourprod-header">
        <h3>Beats</h3>

        <CouponControls {...props} category="beat" />
      </div>

      <div className="products-grid">
        {beats.map((beat) => (
          <BeatCard key={beat.$id} beat={beat} {...props} />
        ))}
      </div>
    </>
  );
}

export default BeatsSection;
